<app-navbar [domain]="domain" ></app-navbar>
<!-- <div class="row mt-5">
  <div class="col-lg-1 ol-xl-1"></div>
  <div class="col-sm-12	col-md-12	col-lg-10 col-xl-10">
      <app-iframe [srcInput]="settings.src" [restURL]="settings.restURL" [redirectURL]="settings.redirectURL"></app-iframe>
  </div>
  <div class="col-lg-1 ol-xl-1"></div>
</div> -->
<div class="mainContent">
  <app-iframe *ngIf="!loading" [domain]="urlDomain" [srcInput]="settings.src" [restURL]="settings.restURL" [redirectURL]="settings.redirectURL" [params]="preferences"></app-iframe>
</div>
<app-footer [domain]="domain" ></app-footer>
